import React, { useState } from 'react';
import {
    WidgetImageDefault,
    WidgetItemName,
    WidgetItemPrice,
    WidgetListItem,
    WidgetListWrapper,
    WidgetPictureWrapper,
    WidgetWrapper,
} from 'src/domains/casino/webview/CasinoGames/jack-pot-widget/JackPotWidget.style';
import { deviceSize } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { observer } from 'src/utils/mobx-react';
import mobileDreamDropLogo from './logo-mobile.png';
import desktopDreamDropLogo from './logo-desktop.png';
import { useCommon } from 'src/domains/common/Common';
import { JackpotWidgetState } from 'src/domains/casino/webview/CasinoGames/jack-pot-widget/JackpotWidget.state';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';

export const JackPotWidget = observer('JackPotWidget', (): JSX.Element => {
    const common = useCommon();
    const basicData = BasicDataModel.get(common);
    const [state] = useState(() => new JackpotWidgetState(common));

    return (
        <WidgetWrapper>
            <WidgetPictureWrapper>
                <source
                    media={`(min-width: ${deviceSize.largeDesktop}px)`}
                    srcSet={desktopDreamDropLogo}
                />
                <WidgetImageDefault
                    src={mobileDreamDropLogo}
                    alt='DreamDrop Jackpots logotype'
                />
            </WidgetPictureWrapper>

            <WidgetListWrapper>
                <WidgetListItem>
                    <WidgetItemName>Mega</WidgetItemName>
                    <WidgetItemPrice>{state.megaJackpot?.format(basicData.currency) ?? ''}</WidgetItemPrice>
                </WidgetListItem>

                <WidgetListItem>
                    <WidgetItemName>Maxi</WidgetItemName>
                    <WidgetItemPrice>{state.maxiJackpot?.format(basicData.currency) ?? ''}</WidgetItemPrice>
                </WidgetListItem>

                <WidgetListItem>
                    <WidgetItemName>Midi</WidgetItemName>
                    <WidgetItemPrice>{state.midiJackpot?.format(basicData.currency) ?? ''}</WidgetItemPrice>
                </WidgetListItem>
            </WidgetListWrapper>
        </WidgetWrapper>
    );
});
